import { isPassActive } from './access';
import { isAdminUser } from './admin';

/** Signed-in home for annual-pass holders and admins. */
export function isMemberHubUser({ user, profile } = {}) {
  if (isAdminUser(user)) return true;
  if (isPassActive(profile?.paidUntil)) return true;
  // L2/L3-only / package buyers without legacy L1 paidUntil still get the member hub.
  const entitlements = profile?.entitlements;
  if (entitlements?.packageLifetime) return true;
  for (const level of ['l2', 'l3']) {
    const until = entitlements?.[level]?.paidUntil;
    if (until && until !== 'deferred' && isPassActive(until)) return true;
    if (until === 'deferred' || entitlements?.[level]?.deferred) return true;
  }
  return false;
}

/** Default destination after auth when `next` is `/` or unset. */
export function memberHomePath({ user, profile, fallback = '/progress' } = {}) {
  if (isMemberHubUser({ user, profile })) return '/dashboard';
  return fallback;
}

/** Client-side dashboard route from useAccess() state. */
export function dashboardPathFromAccess(access) {
  if (!access?.user) return '/';
  // Respect admin prospect preview (paid/isAdmin are cleared there).
  if (access?.paid || access?.paidL2 || access?.paidL3 || access?.hasPackage || access?.isAdmin) {
    return '/dashboard';
  }
  return '/progress';
}
